import { render, staticRenderFns } from "./invAdmin.vue?vue&type=template&id=78f25a48"
import script from "./invAdmin.vue?vue&type=script&lang=js"
export * from "./invAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports